export const GET_ALL_PP = "GET_ALL_PP";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const GET_PP = "GET_PP";
export const GET_PRODUCTS = "GET_PRODUCTS";
export const ADD_PRODUCT_PROPERTIES = "ADD_PRODUCT_PROPERTIES";
export const UPDATE_PRODUCTPROPERTIES = "UPDATE_PRODUCTPROPERTIES";
// Clear product properties
export const CLEAR_PP = "CLEAR_PP";
